import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import About from './components/about';
import Services from './components/Services';
import Projects from './components/Projects';
import Career from './components/Career';
import LetsTalk from './components/LetsTalk';
import JobSearchContainer from './components/JobSearchContainer';
import JobList from './components/JobList';
import HomePage from './components/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/style.css';
import CandidateSearch from  './components/CandidateSearch';
import JoinPage from './components/JoinPage';
import SignInPage from './components/SignInPage'
function App() {
    const [jobs, setJobs] = useState([]);

    return (
     <div className="App" style={{ paddingTop: "6%" }}>

            <Router>
                {/* Ensure Header is included only once here */}
                <Header />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/job-list" element={<JobList jobs={jobs} loading={false} />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                  
                    <Route path="/career" element={<Career />} />
                    <Route path="/lets-talk" element={<LetsTalk />} />
                    <Route path='/candSearch' element={<CandidateSearch/>}></Route>
                    <Route path='/join' element={<JoinPage/>}></Route>
                    <Route path='/signin' element={<SignInPage/>}></Route>
                </Routes>
            </Router>
        </div>
    );
}



export default App;
